import { useContext } from "react";
import VisitorsFunnel from "presentation/components/VisitorsFunnel";
import { VisitorsFunnelSkeleton } from "presentation/components/Skeleton/VisitorsFunnelSkeleton";
import PanelContainer from "presentation/components/PanelContainer";
import { Box } from "@reverb-ui/react";
import { VisitorsFunnelContext } from "../context-api/VisitorsFunnelProvider";

const VisitorsFunnelReports: React.FC = () => {
  const { visitorsFunnelData, isLoading } = useContext(VisitorsFunnelContext);

  return (
    <PanelContainer
      panelName="Visitors funnel"
      rangeName={visitorsFunnelData?.range}
      isLoading={isLoading}
    >
      {isLoading ? (
        <VisitorsFunnelSkeleton />
      ) : (
        <Box h={320}>
          <VisitorsFunnel visitors={visitorsFunnelData?.visitorsFunnel} />
        </Box>
      )}
    </PanelContainer>
  );
};

export default VisitorsFunnelReports;
